module.exports = __webpack_public_path__ + "img/health_thumbnail-400x300.78315312.jpg";